<template>
  <div class="">
    <div class="card card-with-shadow border-0 h-1000">
      <div class="card-header p-primary bg-transparent">
        <h5 class="card-title m-0">{{ $t("add_product") }}</h5>
      </div>
      <app-overlay-loader v-if="preloader" />
      <div class="card-body">
        <form ref="form" :data-url="selectedUrl ? `products/${inputs.id}` : `products`" class="mb-0" :class="{ 'loading-opacity': preloader }" >
          <div class="form-group row align-items-center">
            <label class="col-md-2 mb-md-0">
              {{ $t("name") }}
            </label>
            <app-input
              class="col-md-8"
              type="text"
              v-model="inputs.name"
              :placeholder="$t('type_name')"
            />
          </div>

          <div class="form-group row align-items-center">
            <label class="col-md-2 mb-md-0">
              {{ $t("add_dutty") }} / {{ $t("tariff") }}
            </label>
            <div class="col-md-10 mt-2 pt-1">
              <div v-for="(row, index) in rows" :key="index" class="row mb-2">
                <SelectCustom v-model="row.subCategory" divGridClass="col-md-2" :list="sub_categories" label="Sub category" />
                <app-input
                  class="col-md-2"
                  :placeholder="$t('country_of_origin')"
                  type="advance-search-select"
                  fetch-url="/countries/serverside/selectable-name"
                  v-model="row.countryFrom"
                  listValueField="name"
                  :loaded-per-time="5"
                />
                <app-input
                  class="col-md-2"
                  :placeholder="$t('country_of_destination')"
                  type="advance-search-select"
                  fetch-url="/countries/serverside/selectable-name"
                  v-model="row.countryTo"
                  listValueField="name"
                  :loaded-per-time="5"
                />
                <app-input
                  class="col-md-2"
                  type="text"
                  v-model="row.hts_code"
                  :placeholder="$t('hts_code')"
                  :disabled="false"
                />
                <app-input
                  class="col-md-1 mr-0 pr-0"
                  type="number"
                  v-model="row.dutyDisplay"
                  :placeholder="$t('duty_rate')"
                  :disabled="false"
                  @focus="$event.target.select()"
                />
                <!-- <div class="col-md-2 mr-0 pr-0"></div>
                <div class="col-md-2 mr-0 pr-0"></div>
                <div class="col-md-2 mr-0 pr-0"></div>
                <div class="col-md-2 mr-0 pr-0"></div>
                <div class="col-md-2 mr-0 pr-0"></div> -->
                <app-input
                  class="col-md-1 mr-0 pr-0"
                  type='number'
                  v-model="row.tariffDisplay"
                  :placeholder="$t('tariff_rate')"
                  :disabled="false"
                  @focus="$event.target.select()"
                />
                <button
                  v-if="index == 0"
                    type="button"
                    class="btn btn-success h-100 ml-15 pl-15"
                    @click="addRow"
                  >
                    +
                  </button>
                  <button
                    v-if="index != 0"
                    type="button"
                    class="btn btn-danger h-100 ml-15 pl-15"
                    @click="removeRow(index)"
                  >
                    -
                  </button>
              </div>
            </div>
          </div>

          <!-- buiding image -->

          <div class="form-group row mb-0">
            <label class="col-sm-2 mb-sm-0">
              {{ $t("upload_with_preview") }}
            </label>
            <div class="col-sm-8">
              <app-input
                type="custom-file-upload"
                :label="$t('upload_your_file')"
                v-model="inputs.custom_file"
              />
              <small class="text-muted font-italic">
                {{ $t("recommended_custom_file_validation") }}
              </small>
            </div>
          </div>

          <div class="form-group row align-items-center">
            <label class="col-md-2 mb-md-0">
              {{ $t("status") }}
            </label>
            <app-input
              class="col-md-8 mt-2 pt-1"
              type="radio"
              :list="genderLists"
              v-model="inputs.status"
            />
          </div>

          <div class="mt-5 action-buttons">
            <button
              type="submit"
              class="btn btn-primary mr-2"
              @click.prevent="submit"
            >
              {{ $t("add") }}
            </button>
            <button
              type="submit"
              class="btn btn-secondary"
              @click.prevent="clear"
            >
              {{ $t("clear") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import SelectCustom from "../components/SelectCustom.vue";

export default {
  name: "AddProductModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  components : {
    SelectCustom
  },
  data() {
    return {
      sub_categories: [],
      rows: [{ subCategory:null, countryFrom: "", countryTo: "", tariff: 0, duty: 0, duty_number : '', dutyDisplay : 0, tariffDisplay: 0, hts_code:'' }],

      preloader: false,
      inputs: {
        category: {
          id: null,
          name: null,
        },
        hts_code: null,
        status: "active",
      },
      genderLists: [
        { id: "active", value: "Active" },
        { id: "inactive", value: "Inactive" },
      ],
    };
  },
  async created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
    this.sub_categories = await this.get_data_customTable('sub_category');
  },
   watch: {
        rows: {
            deep: true,
                handler(newRows) {
                    newRows.forEach(row => {
                        let num = parseFloat(row.dutyDisplay);
                        row.duty = isNaN(num) ? 0 : num;
                        num = parseFloat(row.tariffDisplay);
                        row.tariff = isNaN(num) ? 0 : num;
                    });
                }
        }
    },
  methods: {
    async get_data_customTable (customTable) {
      let obj = {};
      let array = [];
      try {
          // se debe consultar por el nombre para encontrar el id
          const resId = await axios.get(`/admin/app/custom-table/serverside/id/${customTable}`);
          if (resId.data.id) {
              const response = await axios.get(`/admin/app/custom-table/values/${resId.data.id}`);
              const dataRes = response.data.data;
              for (let index = 0; index < dataRes.length; index++) {
                  const element = dataRes[index]['field_values'];
                  for (let y = 0; y < element.length; y++) {
                      if (y == 0) {
                          obj = {'id' : element[y]['id'], 'value' : element[y]['value']};
                          array.push(obj);
                      }
                  }
              }
              return array;
          }
      } catch (error) {
          console.error('Error fetching data:', error);
      }
  },

    addRow() {
      this.rows.push({ countryFrom: "", countryTo: "", tariff: "", duty: "", rate:'', duty_number : '', dutyDisplay : 0, tariffDisplay : 0 });
    },

    removeRow(index) {
      this.rows.splice(index, 1);
    },



    submit() {
      if (!this.inputs.name) {
        this.$toastr.e(this.$t("Complete_the_name"));
        return;
      }

      this.inputs["category_id"] = this.inputs.category.id;

      if (
        this.rows[0].subCategory === null ||
        this.rows[0].countryFrom == "" ||
        this.rows[0].countryTo == "" ||
        this.rows[0].hts_code == ""
      ) {
        this.$toastr.e(this.$t("add_tariff_required"));
        return;
      }

      let formData = new FormData();

      const { custom_file } = this.inputs;
      if (custom_file) {
        formData.append("custom_file", custom_file);
      }

      formData.append("name", this.inputs.name);
      formData.append("status", this.inputs.status);
      formData.append("category_id", this.inputs.category.id);

      formData.append("tariff", JSON.stringify(this.rows));

      this.save(formData);
  },


    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      // this.$hub.$emit('reload-' + this.tableId);
      if (response.data.redirect) {
        window.location.href = response.data.redirect;
      } else {
        console.error("No redirect URL found in response.");
      }
    },
    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
    beforeSubmit() {
      this.preloader = true;
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {
        gender: "male",
      };
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    clear() {
      this.inputs = {
        gender: "male",
      };
      this.fieldStatus = {
        isSubmit: false,
      };
    },
  },
};
</script>
